// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function SectionLabel(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "text-zinc-500 text-sm font-semibold uppercase tracking-wide",
      className
    ])
  });
}

let make = SectionLabel;

exports.make = make;
/* tailwind-merge Not a pure module */
